export enum EDeclaredCompanyRevenue {
  UP_TO_81000 = 'DCRB01', // Up to R$ 81,000 (MEI)
  FROM_81001_TO_360000 = 'DCRB02', // R$ 81,001 – R$ 360,000 (Microempresa)
  FROM_360001_TO_4800000 = 'DCRB03', // R$ 360,001 – R$ 4,800,000 (EPP)
  FROM_4800001_TO_78000000 = 'DCRB04', // R$ 4,800,001 – R$ 78,000,000 (Média Empresa)
  ABOVE_78000000 = 'DCRB05', // Above R$ 78,000,000 (Grande Empresa)
}

export enum EOwnerDeclaredRevenue {
  UP_TO_81000 = 'ODRB01', // Up to R$ 81,000 (MEI)
  FROM_81001_TO_360000 = 'ODRB02', // R$ 81,001 – R$ 360,000 (Microempresa)
  FROM_360001_TO_4800000 = 'ODRB03', // R$ 360,001 – R$ 4,800,000 (EPP)
  FROM_4800001_TO_78000000 = 'ODRB04', // R$ 4,800,001 – R$ 78,000,000 (Média Empresa)
  ABOVE_78000000 = 'ODRB05', // Above R$ 78,000,000 (Grande Empresa)
}

export enum EOwnerDeclaredIncome {
  UP_TO_5000 = 'ODIB01', // Up to R$ 5,000
  FROM_5001_TO_10000 = 'ODIB02', // R$ 5,001 – R$ 10,000
  FROM_10001_TO_30000 = 'ODIB03', // R$ 10,001 – R$ 30,000
  FROM_30001_TO_100000 = 'ODIB04', // R$ 30,001 – R$ 100,000
  ABOVE_100000 = 'ODIB05', // Above R$ 100,000
}
